import { BASE_URL } from '../utils/constant';
import { localStore } from '../App';

class BatimetricService 
{
  async fetchBatimetric(): Promise<any> 
  {
    // Check if we should fetch from remote based on time of day and last fetch
    const shouldFetchRemote = async () => {
      const now = new Date();
      const lastFetchDate = await localStore.get("lastBatimetricFetch");
      
      // If we have a last fetch date, check if it was today after 1pm
      if (lastFetchDate) 
      {
        const lastFetch = new Date(lastFetchDate);
        const isToday = lastFetch.toDateString() === now.toDateString();
        const isAfter1PM = lastFetch.getHours() >= 13;
        
        // If we already fetched today after 1pm, use local storage
        if (isToday && isAfter1PM) 
        {
          return false;
        }
      }
      
      // Fetch from remote if it's after 1pm, otherwise use local
      return now.getHours() >= 13;
    };

    // Check if we should fetch from remote
    if (await shouldFetchRemote() || true) 
    {
      const remoteBatimetric = await this.fetchRemoteBatimetric();
      if (remoteBatimetric) 
      {
        // Store the fetch timestamp
        await localStore.set("lastBatimetricFetch", new Date().toISOString());
        console.log('fetchBatimetric:: Informazioni batimetriche scaricarte dal server.');
        return remoteBatimetric;
      }
    }

    const localData = await this.fetchBatimetricFromStorage();
    if (!localData) // if local data is null, fetch from remote anyway
    {
      return this.fetchRemoteBatimetric();
    }
    return localData;
  }


  async fetchBatimetricFromStorage(): Promise<any> 
  {
    try 
    {
      console.log('fetchBatimetricFromStorage:: cerco informazioni batimetriche in memoria');
      
      const batimetric = await localStore.get("batimetriclist");
      if (batimetric != null) 
      {
        console.log('fetchBatimetricFromStorage:: Informazioni batimetriche presenti in memoria.');
        return batimetric;
      }

      console.log('Non sono presenti informazioni batimetriche in memoria - riavviare l\'app e  riprovare');
      return null;
    }
    catch (error) 
    {
      console.log('Problema nella ricezione dei dati batimetrici - riavviare l\'app e riprovare ', error);
      throw error;
    }
  }


  
  async fetchRemoteBatimetric(): Promise<[any] | null> 
  {
    console.log('fetchRemoteBatimetric:: cerco informazioni batimetriche sul server');

    return new Promise((resolve, reject) => {
      const url = `${BASE_URL}/poServer.php?act=15&h=gkzLoFk0MN58TGqCJj`;
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => 
          {
            console.log('Informazioni batimetriche scaricarte dal server.');
            localStore.set('batimetriclist', result.content);
            resolve(result.content);
          },
          (error) => {
            console.log('Problema nella ricezione dei dati batimetrici - controlliamo se ce ne sono in memoria ', error);
            resolve(null);
          }
        );
    });
  }
}

export default BatimetricService; 